import { JWT_NAME } from "./globals";

export function setJwt(token: string) {
  localStorage.setItem(JWT_NAME, token);
}

export function clearJwt() {
  localStorage.removeItem(JWT_NAME);
}

export function getJwt(): string | null {
  return localStorage.getItem(JWT_NAME);
}
